/* elihe Laboratories — Precision Motion v1 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = function (t) { return 1 - Math.pow(1 - t, 4); }; // easeOutQuart

  function onView(el, cb, threshold) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.disconnect(); cb(); }
      });
    }, { threshold: threshold || 0.35 });
    io.observe(el);
  }

  /* 2. Measured stats — lab-readout count-up + crimson gauge */
  function stats() {
    var first = document.querySelector('.eh-stat');
    if (!first) return;
    var band = first.parentElement;
    band.classList.add('em-stats');
    var items = band.querySelectorAll('.eh-stat');
    var below = band.getBoundingClientRect().top > window.innerHeight;
    items.forEach(function (st) {
      var sp = st.querySelector('.eh-num span');
      if (sp) {
        sp.dataset.emTarget = parseInt(sp.textContent, 10); // real figures stay in the HTML for SEO/crawlers
      }
      var num = st.querySelector('.eh-num');
      if (num && !st.querySelector('.em-gauge')) {
        var g = document.createElement('span');
        g.className = 'em-gauge';
        g.setAttribute('aria-hidden', 'true');
        num.insertAdjacentElement('afterend', g);
      }
    });
    onView(band, function () {
      band.classList.add('is-in');
      if (reduce) return;
      items.forEach(function (st, i) {
        var span = st.querySelector('.eh-num span');
        if (!span) return;
        var target = parseInt(span.dataset.emTarget, 10);
        if (isNaN(target)) return;
        if (!below) return; // already visible on load: leave real figure, no re-count
        var dur = 2800, start = null, delay = i * 240;
        span.textContent = '0%';
        setTimeout(function () {
          requestAnimationFrame(function step(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            span.textContent = Math.round(target * ease(p)) + '%';
            if (p < 1) requestAnimationFrame(step);
          });
        }, delay);
      });
    });
  }

  /* 3. Focus pull — science + editorial images come into focus (flip card excluded) */
  function focus() {
    if (reduce) return;
    document.querySelectorAll('.eh-figure:not(.eh-flip)').forEach(function (fig) {
      fig.classList.add('em-focus');
      onView(fig, function () { fig.classList.add('is-in'); }, 0.3);
    });
    document.querySelectorAll('.elihe-about .elihe-media').forEach(function (m) {   // About page photos
      m.classList.add('em-focus');
      onView(m, function () { m.classList.add('is-in'); }, 0.3);
    });
    document.querySelectorAll('.eh-benefit img').forEach(function (im) {
      im.classList.add('em-focus-soft');
      onView(im, function () { im.classList.add('is-in'); }, 0.3);
    });
  }

  /* 4. Section rise — label, heading, text, then cards/tiles, one after another */
  function rise() {
    if (reduce) return;
    var skip = '.eh-stats, details, .eh-reviews, .scroll-trigger';   // stats has its own motion; FAQ + reviews stay static
    var grids = '.eh-products, .eh-benefits, .eh-routine, .eh-ig, .eh-pillars';
    function collect(box, out) {
      Array.prototype.forEach.call(box.children, function (c) {
        if (/^(SCRIPT|STYLE|LINK)$/.test(c.tagName) || c.matches('.eh-figure')) return;
        if (c.matches(grids)) { Array.prototype.push.apply(out, c.children); return; }
        if (c.tagName === 'DIV' && !c.className && c.querySelector('h2')) { collect(c, out); return; } // text column in split layouts
        out.push(c);
      });
    }
    var groups = [];
    document.querySelectorAll('.elihe-home > section').forEach(function (sec) {
      if (sec.querySelector(skip)) return;
      var units = []; collect(sec.querySelector('.eh-wrap') || sec, units);
      groups.push({ el: sec, units: units });
    });
    // About page sections (FAQ stays static)
    function collectAbout(box, out) {
      Array.prototype.forEach.call(box.children, function (c) {
        if (/^(SCRIPT|STYLE|LINK)$/.test(c.tagName) || c.matches('.elihe-media')) return;
        if (c.matches('.wrap, .copy, .center, .pillars, .stat-grid, .feature-grid')) { collectAbout(c, out); return; }
        out.push(c);
      });
    }
    document.querySelectorAll('.elihe-about > section').forEach(function (sec) {
      if (sec.querySelector('details')) return;
      var units = []; collectAbout(sec, units);
      groups.push({ el: sec, units: units });
    });
    var bv = document.querySelector('.eh-bv__inner');
    if (bv) groups.push({ el: bv, units: Array.prototype.filter.call(bv.children, function (c) { return !c.matches('.eh-bv__stage, script'); }) });
    if (/\/products\//.test(location.pathname)) {          // product pages (page-builder sections rise as whole blocks)
      document.querySelectorAll('.beae-builder section').forEach(function (s) {
        if (!s.parentElement.closest('section')) groups.push({ el: s, units: [s] });
      });
    }
    // blog listing (not articles): each post card rises as it arrives, left to right along the row
    if (/^\/blogs\/[^\/]+\/?$/.test(location.pathname)) {
      var cards = document.querySelectorAll('.beae-blog-post-card');
      var lefts = [];
      cards.forEach(function (cd) { var l = Math.round(cd.getBoundingClientRect().left); if (lefts.indexOf(l) < 0) lefts.push(l); });
      lefts.sort(function (a, b) { return a - b; });
      cards.forEach(function (cd) {
        groups.push({ el: cd, units: [cd], base: lefts.indexOf(Math.round(cd.getBoundingClientRect().left)) * 0.3 });
      });
    }
    groups.forEach(function (g) {
      if (!g.units.length) return;
      if (g.el.getBoundingClientRect().top < window.innerHeight) return; // already on screen at load: leave it
      g.units.forEach(function (u, i) {
        u.classList.add('em-rise');
        u.style.setProperty('--em-d', ((g.base || 0) + Math.min(i * 0.3, 1.8)) + 's');
      });
      onView(g.el, function () {
        g.units.forEach(function (u) { u.classList.add('is-in'); });
        setTimeout(function () {                              // hand styles back to the theme once settled
          g.units.forEach(function (u) { u.classList.remove('em-rise', 'is-in'); u.style.removeProperty('--em-d'); });
        }, 4600);
      }, 0.12);
    });
  }

  function init() { stats(); focus(); rise(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
